import {
    renderAvgPriceOdoChart,
    renderDeprecationChart,
    renderPriceHistogramChart,
    renderPriceOdoChart
} from "../utils/charts";
import {trans} from "../i18n/i18n";
import * as details_enum from "../consts/details";
import * as decode_enum from "../enums/decode";

document.addEventListener('DOMContentLoaded', () => {
    const vmvPage = document.getElementById('vmv-page');

    if(!vmvPage){
        return;
    }

    const loadingElement = document.getElementById('vmv-loading');
    const chartsSection = document.getElementById('charts-section');

    // Function to load market value data
    function loadMarketValueData() {
        // Get market value data from the data attribute
        const marketValueDataStr = vmvPage.querySelector('#vehicle-market-value').getAttribute('data-market-value');

        if (marketValueDataStr) {
            try {
                const marketValueData = JSON.parse(marketValueDataStr);
                renderMarketValueData(marketValueData);
            } catch (error) {
                if (error instanceof SyntaxError) {
                    console.error('loadMarketValueData: Error parsing market value data:', error);
                } else {
                    console.error('loadMarketValueData: Error occurred:', error);
                }
                loadingElement.innerHTML = trans('Error occurred while loading market value data');
            }
        } else {
            loadingElement.innerHTML = trans('No market value data available');
        }        
    }

    // Function to render market value data
    function renderMarketValueData(data) {
        const { vin, police, wreckage, decode, chart } = data;

        const allRequestsSuccessful = Object.values({police,wreckage,decode,chart}).every(category => {
            return Object.values(category).every(item => item.request_status === true);
        });

        if (!allRequestsSuccessful) {
            throw new Error('One or more decode items have request_status: false');
        }

        const make = decode[decode_enum.DECODE_GLOBAL]['details'][details_enum.GROUP_BASIC_VEHICLE_IDENTIFICATION]?.[details_enum.DETAIL_MAKE]?.value;
        const model = decode[decode_enum.DECODE_GLOBAL]['details'][details_enum.GROUP_BASIC_VEHICLE_IDENTIFICATION]?.[details_enum.DETAIL_MODEL]?.value;
        const year = decode[decode_enum.DECODE_GLOBAL]['details'][details_enum.GROUP_BASIC_VEHICLE_IDENTIFICATION]?.[details_enum.DETAIL_MODEL_YEAR]?.value;

        if (make && model && year) {
            document.getElementById('make-model').textContent = `${make} ${model}`;
            document.getElementById('make-model-year').textContent = `${make} ${model} ${year}`;
            document.getElementById('make-model-year-map').textContent = `${make} ${model} ${year}`;
            document.getElementById('make-model-year-depreciation').textContent = `${make} ${model} ${year}`;

            try {
                renderAvgPriceOdoChart({ data: chart[decode_enum.AVG_PRICE_AND_ODO_CHART]?.details, make, model, year });
                renderPriceHistogramChart({ data: chart[decode_enum.PRICE_VS_ODO_CHART]?.details, make, model, year });
                renderPriceOdoChart({ data: chart[decode_enum.PRICE_VS_ODO_CHART]?.details, make, model, year });
                renderDeprecationChart(chart[decode_enum.DEPRECATION_CHART]?.details);
            } catch (renderError) {
                console.error('Error rendering charts:', renderError);
                loadingElement.innerHTML = 'Error rendering charts';
                return;
            }

            loadingElement.classList.add('d-none');
            chartsSection.classList.remove('d-none');
        } else {
            throw new Error('Missing vehicle details: make, model, or year');
        }
    }

    // Load market value data on page load
    loadMarketValueData();
});
